const LogoWall = () => null;

export default LogoWall;
